<template>
  <span>
    <v-card-title>
      <v-row no-gutters align="center" justify="center">
        <v-col>
          {{ $t("label.caseReport") + " - " + caseReport.searchCase.name }}
          <v-avatar
            v-if="caseReport.searchCase.id"
            class="ml-2"
            color="green"
            size="20"
            title="Case saved"
          >
            <v-icon x-small dark> mdi-check </v-icon>
          </v-avatar>
        </v-col>
        <v-col align="right">
          <v-btn
            v-if="caseReport.searchCase.id"
            class="ma-3"
            fab
            dark
            x-small
            title="Update Case"
            color="green accent-5"
            @click="onLimitedEditCaseClick()"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-else
            class="ma-3"
            fab
            dark
            x-small
            color="blue"
            :title="$t('modal.addCase.title')"
            @click="onAddCaseClick()"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <template v-if="backButton">
        <v-btn x-small @click="$router.back()" icon>
          <v-icon color="blue" title="Back">mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      {{ formatDateTime(caseReport.searchDate) }} by
      {{ caseReport.screenedByUserName }}
    </v-card-subtitle>

    <AddCase
      :visible="isAddModalVisible"
      :parentCaseReportId="caseReport.id"
      :templateCase="caseReport.searchCase"
      :templated="true"
      :caseGroups="getCaseGroups"
      v-on:onConfirmed="onAddCaseConfirmed"
      v-on:onCancelled="onAddCaseCancelled"
    />

    <LimitedEditCase
      :visible="isLimitedEditModalVisible"
      :caseRecord="caseRecord"
      :caseGroups="getCaseGroups"
      v-on:onConfirmed="onLimitedEditCaseClose"
      v-on:onCancelled="onLimitedEditCaseClose"
    />
  </span>
</template>

<script>
import { formatDateTime, formatDate } from "../utils/dateUtils";
import AddCase from "../modals/case/AddCase";
import LimitedEditCase from "../modals/case/LimitedEditCase";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CaseReportHeader",
  components: {
    AddCase,
    LimitedEditCase,
  },
  data() {
    return {
      isAddModalVisible: false,
      isLimitedEditModalVisible: false,
      caseRecord: {},
    };
  },
  props: {
    caseReport: {},
    backButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["getCaseGroups", "users"]),
  },
  methods: {
    formatDateTime,
    formatDate,
    ...mapActions(["fetchCaseGroups", "setGlobalAlert"]),
    onAddCaseClick() {
      this.isAddModalVisible = true;
    },
    onAddCaseConfirmed(caseId) {
      this.caseReport.searchCase.id = caseId; // Triggers UI to toggle add for edit button
      this.isAddModalVisible = false;
    },
    onAddCaseCancelled() {
      this.isAddModalVisible = false;
    },
    async onLimitedEditCaseClick() {
      // fetch full caseReport and set to modals prop
      // TODO only fetch if not already fetched (check for null before fetch)
      await axios
        .get("api/case/" + this.caseReport.searchCase.id)
        .then((response) => {
          this.caseRecord = response.data;
          this.isLimitedEditModalVisible = true;
        })
        .catch(() => {
          this.setGlobalAlert({
            alert: true,
            color: "red",
            alertTitle: "Oops.",
            alertMessage:
              "Unable to edit case settings at this time, please try again.",
          });
        });
    },
    onLimitedEditCaseClose() {
      this.isLimitedEditModalVisible = false;
    },
  },
  async created () {
    if (!this.$store.state.caseGroups.length) {
      this.fetchCaseGroups().catch((e) => {
        console.log("Error getting groups: " + e);
        this.setGlobalAlert({
          alert: true,
          color: "red",
          alertTitle: null,
          alertMessage:
            this.$t("error.caseGroups.error"),
        });
      });
    }
  },
};
</script>